<template>
  <modal name="foreignerAgree" height="auto" @before-close="beforeClose">
    <div class="dialog__inner">
      <div class="popup-header">
        <h1 tabindex="0">외국인 등록번호 수집, 이용동의(필수)</h1>
        <button
          type="button"
          class="btn_popup_close"
          data-dismiss="modal"
          title="팝업닫기"
          @click="closeDialog"
        >
          <span>팝업 닫기</span>
        </button>
      </div>
      <div class="dialog__content">
        <div class="section">
          <div class="section-body">
            <ul class="notice-text-list" tabindex="0">
              <li class="notice-text">
                수집이용 목적 : 본인확인, 본인인증, 미환급금 안내, 실명인증
              </li>
              <li class="notice-text">
                수집 정보의 항목 : 외국인등록번호(본인, 대리인 신분확인 이미지
                및 내용포함)
              </li>
              <li class="notice-text">
                정보의 보유 및 이용기간 : 서비스 가입기간 동안 이용하고,
                요금정산 과,<br />
                오납 분쟁대비를 위하여 해지 후 요급완납 후 6개월까지 이용
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="dialog__footer">
        <button class="button close primary-button" @click="confirmDialog">
          확인
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'ForeignerAgreePopup',

  props: {
    message: String
  },


  created() {
  },

  computed: {},

  methods: {
    /** 
     * Function    : closeDialog
     * Description : Dialog 닫기
     **/
    closeDialog() {
      this.$modal.hide('foreignerAgree')
    },

    beforeClose() {
      if(!this.$store.state.isConfirm) {
        this.$emit('close', {
          id: 'fail',
          ok: 'N'
        })
      }
      this.$store.state.isConfirm = false
    },

    /** 
     * Function    : confirmDialog
     * Description : 확인 클릭 시 이벤트 함수
     **/
    confirmDialog() {
      this.$store.state.isConfirm = true
      this.$emit('close', {
        id: 'ok',
        ok: 'Y'
      })
      this.$modal.hide('foreignerAgree')
    }
  }
}
</script>

<style scoped></style>
